import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "behaviorevents"
    }}>{`BehaviorEvents`}</h1>
    <p>{`Behavior trigger event options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MOUSE_UP`}</strong>{` = 1836410230`}</p>
      <p parentName="blockquote">{`Triggers the behavior when the mouse is released after a click.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MOUSE_DOWN`}</strong>{` = 1835296118`}</p>
      <p parentName="blockquote">{`Triggers the behavior when the mouse button is clicked (without being released).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MOUSE_ENTER`}</strong>{` = 1835361654`}</p>
      <p parentName="blockquote">{`Triggers the behavior when the mouse pointer enters the area defined by the bounding box of the object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MOUSE_EXIT`}</strong>{` = 1836606838`}</p>
      <p parentName="blockquote">{`Triggers the behavior when the mouse pointer exits the area defined by the bounding box of the object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ON_FOCUS`}</strong>{` = 1868981622`}</p>
      <p parentName="blockquote">{`Triggers the behavior when the object receives focus, either through a mouse action or by pressing the Tab key.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ON_BLUR`}</strong>{` = 1868719478`}</p>
      <p parentName="blockquote">{`Triggers the behavior when the focus moves to a different interactive object.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      